import styled from 'styled-components'
import { bodyPrimaryColor, bodySecondaryColor } from 'styles/styleVariables'

type AccessDeniedProps = {
  title?: string
  message?: string
}

const AccessDenied = ({
  title = 'Access denied',
  message = 'You do not have permission to view this page.',
}: AccessDeniedProps): JSX.Element => (
  <Container data-testid="access-denied">
    <Title>{title}</Title>
    <Message>{message}</Message>
  </Container>
)

const Container = styled.div`
  margin: 2rem;
`

const Title = styled.h1`
  color: ${bodyPrimaryColor};
`

const Message = styled.p`
  margin: 0.625rem 0;
  color: ${bodySecondaryColor};
`

export default AccessDenied
